import { Link } from "react-router-dom";

export default function CtaSection() {
  return (
    <section className="mx-auto w-full max-w-[1400px] px-4 pb-16 md:px-6 md:pb-20">
      <div className="relative overflow-hidden rounded-lg border border-accent-300/30">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20mystery%20theatre%20stage%20curtain%20with%20crimson%20and%20gold%20lighting%20beams%2C%20silhouette%20of%20a%20detective%20silhouette%2C%20noir%20atmosphere%2C%20stylized%20dramatic%20illustration%2C%20deep%20shadows&width=1600&height=600&seq=cta-hanhan&orientation=landscape"
          alt="汗汗漫画开启推理之旅背景"
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/70 to-background-950/40"></div>
        <div className="relative z-10 flex flex-col items-start gap-5 px-6 py-14 md:flex-row md:items-center md:justify-between md:px-12 md:py-20">
          <div className="max-w-xl">
            <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
              烧脑反转 · 高能追更不停歇
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-300 md:text-base">
              悬疑、推理、烧脑、反转、案件、解密，六大类型佳作持续更新，
              现在就开启你的推理阅读之旅。
            </p>
          </div>
          <Link
            to="/category/xuangyi"
            className="inline-flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-7 py-3 text-sm font-semibold text-background-950 transition-colors hover:bg-accent-400"
          >
            <i className="ri-flashlight-line" aria-hidden="true"></i>
            开始追更
          </Link>
        </div>
      </div>
    </section>
  );
}